<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input v-model="search.invoice_id"
                           class="form-control mr-sm-2"
                           type="search"
                           placeholder="เลขที่ใบแจ้งหนี้"
                           aria-label="Search"/>
                    <date-picker
                        v-model="search.date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        @clear="clearDate"
                        :not-after="currentDate"
                        placeholder="วันที่สร้างใบแจ้งหนี้">
                    </date-picker>
                    <multiselect
                        v-model="search.seller"
                        class="form-control select"
                        placeholder="เซลล์"
                        :options="sellerList"
                        label="name"
                        :show-labels="false"
                        track-by="name">
                    </multiselect>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchSaveExportation"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <router-link to="save-exportation-form">
                        <button
                            class="btn btn-warning my-2 my-sm-0"
                            type="button"
                            v-if="canViewSuperAdmin || canViewDriver || this.user.username == '20516'"
                        >
                            <icon name="plus"></icon>
                            บันทึกส่งของ
                        </button>
                    </router-link>
                    &nbsp
                    <button
                        class="btn btn-warning my-2 my-sm-0"
                        type="button"
                        @click="pdf"
                    >
                        <icon name="print"></icon>
                        รายงานบันทึกส่งของ
                    </button>
                    &nbsp
                    <button
                        class="btn btn-warning my-2 my-sm-0"
                        type="button"
                        @click="pdfDriver"
                    >
                        <icon name="print"></icon>
                        รายงานบันทึกส่งของ(คนรถ)
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <td scope="col">เลขที่ใบแจ้งหนี้</td>
                    <th scope="col">วันที่ใบแจ้งหนี้</th>
                    <th scope="col">วันที่ส่งสินค้า</th>
                    <th scope="col">เซลล์</th>
                    <th scope="col">รหัสลูกค้า</th>
                    <th scope="col">ชื่อลูกค้า</th>
                    <th scope="col">ชื่อคนรถ</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">สถานะ</th>
                    <!--<th width="150px" scope="col">สถานะ</th>-->
                    <th scope="col">การเก็บเงิน</th>
                    <th scope="col">ช่องทาง</th>
                    <th scope="col">ยอดรับ</th>
                    <th scope="col">ผู้อัพเดท</th>
                    <th scope="col">เวลาอัพเดท</th>
                    <th scope="col">รูปถ่ายการส่งของ</th>
                    <th scope="col">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in SaveExportationList">
                    <!--<td>{{data}}</td>-->
                    <td>
                        {{ data.invoice_id }}
                    </td>
                    <td>
                        {{ data.date | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                        <template v-if="data.save_exportation.length > 0">
                            {{ data.save_exportation[0].created_at | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.customer && data.customer.sale">
                            {{ data.customer.sale.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.customer">
                            {{ data.customer.customer_id }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.customer">
                            {{ data.customer.store_name }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.driver">
                            {{ data.driver.name }}
                        </template>
                    </td>
                    <td>
                        {{ data.total | currency }}
                    </td>
                    <td>
                        <template v-if="data.status">
                            {{ data.status.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.save_exportation.length > 0">
                            {{ data.save_exportation[0].amount | currency }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.save_exportation.length > 0">
                            <template v-if="data.save_exportation" v-for="item in data.save_exportation">
                                {{ item.payment_type_name }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.save_exportation.length > 0">
                            <template v-if="data.save_exportation" v-for="(item, index) in data.save_exportation">
                                {{ item.transaction_name }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.save_exportation">
                            <template v-if="data.save_exportation.length > 0 && data.save_exportation[0].update_user">
                                {{ data.save_exportation[0].user.name }}
                            </template>
                            <template v-else>-</template>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.save_exportation">
                            <template v-if="data.save_exportation.length > 0">
                                {{ data.save_exportation[0].updated_at | moment("DD/MM/YYYY H:m") }}
                            </template>
                            <template v-else>-</template>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.save_exportation.length > 0">
                            <template v-if="data.save_exportation[0].image_file != null">
                                <template v-for="(x,i) in data.save_exportation[0].image_file.split(',')"
                                          v-if="i != data.save_exportation[0].image_file.split(',').length-1">
                                    <a :href="domain.slice(0, -4)+'/file/'+x"
                                       style="color: blue;text-decoration:underline"
                                       target="_blank">
                                        ดูรูปถ่ายที่ {{ i + 1 }}
                                    </a>
                                    <br>
                                </template>
                                <!--                                <a :href="data.save_exportation[0].image_file"-->
                                <!--                                   style="color: blue;text-decoration:underline"-->
                                <!--                                target="_blank">-->
                                <!--                                    ดูรูปถ่าย-->
                                <!--                                </a>-->
                            </template>
                            <template v-else>ดูรูปถ่าย</template>
                        </template>
                        <template v-else>ดูรูปถ่าย</template>
                    </td>
                    <td>
                        <template v-if="data.save_exportation.length < 1 || !canViewAccounting">
                            <icon name="pencil-alt" style="color: dimgrey"></icon>
                        </template>
                        <template v-else>
                            <a @click="goToSaveExportationForm(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div v-if="SaveExportationList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSaveExportation">
            </vue-pagination>
        </div>
        <br>
        <!--<pre class="alert alert-primary">{{ SaveExportationList }}</pre>-->

        <!--<br/>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import moment from "moment";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import {canViewAccounting, canViewDriver, canViewSuperAdmin} from "../../../util/Permissions";
import {domain} from "@/util/Constants";

export default {
    components: {
        VuePagination,
        DatePicker,
        Multiselect

    },
    name: "save-exportation-list",
    data() {
        return {
            saveExportation: "",
            event_submit: false,
            currentDate: "",
            changeFormat: {
                stringify: (date) => {
                    if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            domain: domain
        };
    },
    created() {
        this.$store.dispatch("SaveExportation/clearSearch");
        this.$store.dispatch("SaveExportation/setSaveExportation", {'page': 1, 'id': this.user.id});
        this.getCurrentDate();
    },

    computed: {
        canViewAccounting,
        canViewSuperAdmin,
        canViewDriver,
        ...mapState({
            SaveExportationList: state => {
                return state.SaveExportation.SaveExportationList
            },
            dataPaginate: state => {
                return state.SaveExportation.dataPaginate;
            },
            search: state => {
                return state.SaveExportation.search;
            },
            sellerList: state => {
                return state.Seller.data
            },
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    methods: {
        clearDate() {
            this.search.date = [];
        },
        pdf() {
            if (this.search.date.length > 0 && moment(this.search.date[1]).diff(moment(this.search.date[0]), 'days') + 1 > 14) {
                alert('กรุณาเลือกไม่เกิน 14 วัน')
            } else if (this.search.date.length == 0) {
                alert('กรุณาเลือกวันที่')
            } else {
                let data = {
                    invoice_id: this.search.invoice_id,
                    date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                    date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                    seller: this.search.seller,
                    user_id: this.user.id
                }
                window.open(`${domain}/save_exportation_pdf?date_start=${data.date_start}&date_end=${data.date_end}&seller=${data.seller}&user_id=${data.user_id}&invoice_id=${data.invoice_id}`, '_blank')
            }
        },
        pdfDriver() {
            if (this.search.date.length > 0 && moment(this.search.date[1]).diff(moment(this.search.date[0]), 'days') + 1 > 14) {
                alert('กรุณาเลือกไม่เกิน 14 วัน')
            } else if (this.search.date.length == 0) {
                alert('กรุณาเลือกวันที่')
            } else {
                let data = {
                    invoice_id: this.search.invoice_id,
                    date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                    date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                    seller: this.search.seller,
                    user_id: this.user.id
                }
                window.open(`${domain}/save_exportation_pdf_driver?date_start=${data.date_start}&date_end=${data.date_end}&seller=${data.seller}&user_id=${data.user_id}&invoice_id=${data.invoice_id}`, '_blank')
            }
        },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
        },
        showSaveExportation(id) {
            this.$store.dispatch("SaveExportation/showSaveExportation", id);
        },
        goToSaveExportationForm(id) {
            this.showSaveExportation(id);
            this.$router.push({
                name: "save-exportation-form",
                params: {id}
            });
        },
        searchSaveExportation() {
            this.event_submit = true;
            //change date format
            let data = {
                page: 1,
                invoice_id: this.search.invoice_id,
                date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                seller: this.search.seller,
                user_id: this.user.id
            };
            //console.log(data)
            this.$store.dispatch("SaveExportation/search", data)
        },
        getSaveExportation() {
            const page = this.dataPaginate.current_page;
            //change date format
            // if(this.search.date){
            //     this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            // }
            // else{
            //     this.search.date ="";
            // }
            let data = {
                page: page,
                invoice_id: this.search.invoice_id,
                date_start: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                seller: this.search.seller,
                user_id: this.user.id
            };
            //paginate search
            if (this.event_submit) {
                this.$store.dispatch('SaveExportation/search', data)
            }
            //paginate get data
            else {
                this.$store.dispatch('SaveExportation/setSaveExportation', {'page': page, 'id': this.user.id})
            }
        }
    }
};
</script>

<style scoped>
.select {
    border: 0px
}
</style>
